import { useEffect, useState } from 'react';
import { Icon, Message } from 'semantic-ui-react';
import { renderQuestions } from 'src/components/helpers/renderFormQuestions';
import styled from '@emotion/styled';
import { relationsQuestions } from './RelationQuestions';
import { errorInput, scrollUp } from 'src/components/helpers';
import {
  useRecaptchaToken,
  isCaptchaRequired,
  RECAPTCHA_SECURITY_ERROR,
} from 'src/components/helpers/recaptchaUtils';
import crecerFormsInstance from 'src/services/api/crecer';
import Swal from 'sweetalert2';
import { screenSizes } from 'src/assets/styles/Literals';

const StyledFormWrapper = styled.div`
  max-width: 80vw;
  margin: 40px auto;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
  padding: 32px 24px;
  @media (max-width: ${screenSizes.tablet}) {
    max-width: 90vw;
  }
  .relations-questions-title {
    font-size: 22px;
    margin-bottom: 24px;
    color: #2d3748;
    font-weight: 600;
  }
  .checkbox {
    margin-bottom: 12px;
    label {
      font-size: 18px;
      font-weight: 500;
      color: #2d3748;
      margin-bottom: 8px;
    }
    .ui.checkbox label,
    .checkbox-label {
      font-size: 16px;
      color: #4a5568;
      margin-right: 18px;
      cursor: pointer;
    }
  }
  .relations-questions-multiple {
    .ui.checkbox {
      display: block;
      margin-bottom: 24px;
      label {
        font-size: 18px;
        font-weight: 500;
        color: #2d3748;
        margin-bottom: 8px;
      }
    }
  }
  .error {
    color: red !important;
  }
`;
const StyledSection = styled.div`
  margin-bottom: 32px;
`;

const StyledHeader = styled.h2`
  font-size: 1.4rem;
  font-weight: 600;
  margin-bottom: 24px;
  color: #2d3748;
  text-align: center;
`;

const RelationsQuestions = (props) => {
  const { setStep, inputs, setInputs } = props;
  const [errorInputs, setErrorInputs] = useState({});
  const [dateFocused, set_dateFocused] = useState(null);
  const [loading, setLoading] = useState(false);
  const getCaptchaToken = useRecaptchaToken('relations_submit');
  const captchaRequired = isCaptchaRequired();
  const questions = relationsQuestions(inputs);

  useEffect(() => {
    scrollUp();
  }, []);

  const handleInputs = (event) => {
    const { name, value } = event.target;
    setInputs((prev) => ({ ...prev, [name]: value }));
  };

  const verifyForm = () => {
    let errorInputs = {};

    let mandatoryInputs = Object.values(questions)
      ?.filter((a) => !!a.id && !a?.notMandatory)
      ?.map((a) => a.id);

    mandatoryInputs.forEach((input) => {
      errorInputs = errorInput({
        errorInputs,
        input: { name: input, value: inputs?.[input] },
      });
    });

    setErrorInputs(errorInputs);
    return Object.values(errorInputs).includes(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (verifyForm()) return;
    setLoading(true);

    const captcha = await getCaptchaToken({ skip: !captchaRequired });
    if (captchaRequired && !captcha) {
      setLoading(false);
      Swal.fire(RECAPTCHA_SECURITY_ERROR);
      return;
    }

    crecerFormsInstance
      .saveRelationsForm({ ...inputs, captcha })
      .then((response) => {
        if (response.data.success) {
          setStep?.('sent');
        } else {
          Swal.fire({
            title: 'Error',
            text:
              response.data.message ||
              'Ocurrió un error al inscribirte, por favor intenta nuevamente.',
            icon: 'error',
          });
        }
      })
      .catch((error) => {
        Swal.fire({
          title: 'Error',
          text:
            error.response.data.message ||
            'Ocurrió un error al inscribirte, por favor intenta nuevamente.',
          icon: 'error',
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <StyledFormWrapper>
      <form onSubmit={handleSubmit}>
        <StyledSection>
          <StyledHeader>Inscripción al seminario de relaciones sanas</StyledHeader>
          <div className="form-section">
            {renderQuestions({
              questions,
              inputs,
              handleInputs,
              errorInputs,
              setErrorInputs,
              dateFocused,
              set_dateFocused,
              changeStep: (e, direction) => {
                if (direction === 'prev') {
                  setStep?.('initial');
                }
              },
              sending: loading,
              sendForm: handleSubmit,
            })}
            {Object.values(errorInputs).includes(true) && (
              <Message negative>
                <Message.Header>
                  <Icon name="exclamation circle" /> Campos requeridos
                </Message.Header>
                <p>Por favor completa todos los campos obligatorios antes de continuar.</p>
              </Message>
            )}
          </div>
        </StyledSection>
      </form>
    </StyledFormWrapper>
  );
};

export default RelationsQuestions;
